module.exports = __webpack_public_path__ + "static/media/johnson.730d4573.png";